import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';

const root = document.getElementById('root');

const renderFallback = (title, message) => {
  if (!root) return;

  root.innerHTML = `
    <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;padding:24px;background:var(--vylx-bg-primary);color:var(--vylx-text-primary);font-family:system-ui,-apple-system,Segoe UI,Roboto,sans-serif;">
      <div style="width:min(560px,100%);background:var(--vylx-bg-card);border:1px solid var(--vylx-border-medium);border-radius:16px;padding:28px;box-shadow:var(--vylx-shadow-card);text-align:center;">
        <h1 style="margin:0 0 12px;font-size:1.4rem;line-height:1.3;">${title}</h1>
        <p style="margin:0 0 20px;color:var(--vylx-text-muted);line-height:1.5;">${message}</p>
        <button onclick="location.reload()" style="padding:10px 18px;border-radius:10px;border:1px solid var(--vylx-border-neutral-med);background:var(--vylx-bg-secondary);color:var(--vylx-text-primary);cursor:pointer;">Réessayer</button>
      </div>
    </div>
  `;
};

async function bootstrap() {
  if (!root) return;

  try {
    const { default: App } = await import('./App.jsx');

    createRoot(root).render(
      <StrictMode>
        <App />
      </StrictMode>
    );
  } catch (error) {
    console.error('Fatal startup error:', error);
    renderFallback(
      'Application temporairement indisponible',
      'Une erreur de démarrage est survenue. Réessayez ou revenez dans quelques minutes.'
    );
  }
}

bootstrap();